import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { tenantPaymentMethodServices } from "../../../Services/tenantPaymentMethod.service";

const AssignPaymentMethod = ({
  show,
  setShow,
  tenantId,
  onHide,
  setResultModal,
}) => {
  const { t: translator } = useTranslation();
  const { handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [error, setError] = useState();

  const onSubmit = data => {
    if (!paymentMethodId) {
      setError(translator("ValidationMsg-RequiredField"));
      return;
    }
    tenantPaymentMethodServices
      .assignPaymentMethod(tenantId, paymentMethodId)
      .then(res => {
        onHide();
        setResultModal({
          show: true,
          title: translator("CardTypes-AssignPaymentMethod-SuccesModal-Title"),
          text: translator(res.data.message),
          btnClass: "btn btn-primary",
        });
      })
      .catch(err => console.log(err));
  };

  const promiseOptions = inputValue => {
    return tenantPaymentMethodServices
      .getAllPaymentMethods(tenantId)
      .then(res => {
        const result = res.data.data
          .filter(x => x.isDeleted)
          .map(e => ({
            value: e.paymentMethodId,
            label: e.paymentMethodName,
          }));

        return result;
      })
      .catch(err => {
        console.log("err", err.response);
      });
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
      }}
      centered>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {translator("TenantPaymentMethod-AssignTitle")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <fieldset className="scheduler-border">
            <div className="form-group">
              <label htmlFor="ddlStore">
                {translator("Tenant-PaymentMethodName")}
              </label>
              <AsyncSelect
                name="tenantId"
                onChange={event => {
                  setPaymentMethodId(event.value);
                }}
                defaultOptions={true}
                loadOptions={promiseOptions}
                placeholder={translator("Select-PaymentMethod")}
              />

              {error && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
          </fieldset>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}>
            {translator("Btn-Cancel")}
          </Button>
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AssignPaymentMethod;
